import _Cell from './Cell';

import _CellGroup from './CellGroup';

import './style';

export * from './type';

export const Cell = _Cell;

export const CellGroup = _CellGroup;

export default { Cell, CellGroup };
